export type CityInfo = (typeof distributionCenter)[0];
export type CitiesInfo = (typeof distributionCenter)[3];

export const distributionCenter = [
  {
    city: 'forms.cv.cities.msk.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.msk.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '174px',
        left: '250px',
        cx: '28.5%',
        cy: '42.5%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.kot.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.kot.text',
        phone: '+7 495 228 77 12',
        workHours: '10:30-18:30',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '233px',
        left: '268px',
        cx: '31.5%',
        cy: '53%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.che.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.che.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '207px',
        left: '157px',
        cx: '20%',
        cy: '52%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.spb2.text',
    distributionCenters: [
      {
        title: 'forms.cv.cities.spb1.text',
        address: 'contacts.centers.spb1.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '18px',
        left: '147px',
        cx: '25%',
        cy: '10%',
        r: '30%',
      },
      {
        title: 'forms.cv.cities.spb2.text',
        address: 'contacts.centers.spb2.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '75px',
        left: '142px',
        cx: '22%',
        cy: '23%',
        r: '30%',
      },
    ],
  },
  // {
  //   city: 'forms.cv.cities.spb2.text',
  //   address: 'contacts.centers.spb2.text',
  //   phone: '+7 495 228 69 08',
  //   workHours: '08:00-17:00',
  //   images: [
  //     '/images/distribution.jpg',
  //     '/images/distribution.jpg',
  //     '/images/distribution.jpg',
  //   ],
  //   top: '75px',
  //   left: '142px',
  //   cx: '22%',
  //   cy: '23%',
  //   r: '30%',
  // },
  {
    city: 'forms.cv.cities.rostov.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.rostov.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '366px',
        left: '42px',
        cx: '12.5%',
        cy: '73.5%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.kalin.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.kalin.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '53px',
        left: '23px',
        cx: '6.5%',
        cy: '17.5%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.ekat.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.ekat.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '216px',
        left: '463px',
        cx: '62%',
        cy: '60%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.surgut.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.surgut.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '115px',
        left: '483px',
        cx: '62.5%',
        cy: '31.5%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.nsk1.text',
    distributionCenters: [
      {
        title: 'forms.cv.cities.nsk1.text',
        address: 'contacts.centers.nsk1.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '246px',
        left: '637px',
        cx: '82%',
        cy: '60.5%',
        r: '30%',
      },
      {
        title: 'forms.cv.cities.nsk2.text',
        address: 'contacts.centers.nsk2.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '293px',
        left: '635px',
        cx: '83.5%',
        cy: '70%',
        r: '30%',
      },
    ],
  },
  // {
  //   city: 'forms.cv.cities.nsk1.text',
  //   address: 'contacts.centers.nsk2.text',
  //   phone: '+7 495 228 69 08',
  //   workHours: '08:00-17:00',
  //   images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
  //   top: '293px',
  //   left: '635px',
  //   cx: '83.5%',
  //   cy: '70%',
  //   r: '30%',
  // },
  {
    city: 'forms.cv.cities.vv.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.vv.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '345px',
        left: '690px',
        cx: '92.5%',
        cy: '87%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.oez.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.oez.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '308px',
        left: '352px',
        cx: '45%',
        cy: '55%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.red.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.red.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '137px',
        left: '145px',
        cx: '23.5%',
        cy: '40.5%',
        r: '30%',
      },
    ],
  },
  // {
  //   city: 'yelabuga',
  //   address: 'contacts.centers.',
  //   phone: '+7 495 228 69 08',
  //   workHours: '08:00-17:00',
  //   images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
  //   top: '262px',
  //   left: '315px',
  //   cx: '43%',
  //   cy: '64.5%',
  //   r: '30%',
  // },
  // {
  //   city: 'almaty',
  //   address: 'contacts.centers.',
  //   phone: '+7 495 228 69 08',
  //   workHours: '08:00-17:00',
  //   images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
  //   top: '395px',
  //   left: '541px',
  //   cx: '69.5%',
  //   cy: '92%',
  //   r: '30%',
  // },
  // {
  //   city: 'astana',
  //   address: 'contacts.centers.',
  //   phone: '+7 495 228 69 08',
  //   workHours: '08:00-17:00',
  //   images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
  //   top: '320px',
  //   left: '517px',
  //   cx: '66.5%',
  //   cy: '77%',
  //   r: '30%',
  // },
  // {
  //   city: 'minsk',
  //   address: 'contacts.centers.',
  //   phone: '+7 495 228 69 08',
  //   workHours: '08:00-17:00',
  //   images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
  //   top: '132px',
  //   left: '39px',
  //   cx: '7%',
  //   cy: '36%',
  //   r: '30%',
  // },
];

export const distributionCenterRu = [
  {
    city: 'forms.cv.cities.msk.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.msk.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '173px',
        left: '250px',
        cx: '28.5%',
        cy: '42.5%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.kot.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.kot.text',
        phone: '+7 495 228 77 12',
        workHours: '10:30-18:30',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '232px',
        left: '257px',
        cx: '31.5%',
        cy: '53%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.che.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.che.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '209px',
        left: '169px',
        cx: '20%',
        cy: '52%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.spb2.text',
    distributionCenters: [
      {
        title: 'С.Петербург',
        address: 'contacts.centers.spb1.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '18px',
        left: '143px',
        cx: '25%',
        cy: '10%',
        r: '30%',
      },
      {
        title: 'С.Петербург 2',
        address: 'contacts.centers.spb2.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '75px',
        left: '111px',
        cx: '22%',
        cy: '23%',
        r: '30%',
      },
    ],
  },
  // {
  //   city: 'forms.cv.cities.spb2.text',
  //   address: 'contacts.centers.spb2.text',
  //   phone: '+7 495 228 69 08',
  //   workHours: '08:00-17:00',
  //   images: [
  //     '/images/distribution.jpg',
  //     '/images/distribution.jpg',
  //     '/images/distribution.jpg',
  //   ],
  //   top: '75px',
  //   left: '142px',
  //   cx: '22%',
  //   cy: '23%',
  //   r: '30%',
  // },
  {
    city: 'forms.cv.cities.rostov.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.rostov.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '366px',
        left: '34px',
        cx: '12.5%',
        cy: '73.5%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.kalin.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.kalin.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '53px',
        left: '14px',
        cx: '6.5%',
        cy: '17.5%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.ekat.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.ekat.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: [
          '/images/distribution.jpg',
          '/images/distribution.jpg',
          '/images/distribution.jpg',
        ],
        top: '215px',
        left: '458px',
        cx: '62%',
        cy: '60%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.surgut.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.surgut.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '115px',
        left: '482px',
        cx: '62.5%',
        cy: '31.5%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.nsk1.text',
    distributionCenters: [
      {
        title: 'Нск',
        address: 'contacts.centers.nsk1.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '245px',
        left: '629px',
        cx: '82%',
        cy: '60.5%',
        r: '30%',
      },
      {
        title: 'Нск 2',
        address: 'contacts.centers.nsk2.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '293px',
        left: '629px',
        cx: '83.5%',
        cy: '70%',
        r: '30%',
      },
    ],
  },
  // {
  //   city: 'forms.cv.cities.nsk1.text',
  //   address: 'contacts.centers.nsk2.text',
  //   phone: '+7 495 228 69 08',
  //   workHours: '08:00-17:00',
  //   images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
  //   top: '293px',
  //   left: '635px',
  //   cx: '83.5%',
  //   cy: '70%',
  //   r: '30%',
  // },
  {
    city: 'forms.cv.cities.vv.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.vv.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '345px',
        left: '681px',
        cx: '92.5%',
        cy: '87%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.oez.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.oez.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '308px',
        left: '352px',
        cx: '45%',
        cy: '55%',
        r: '30%',
      },
    ],
  },
  {
    city: 'forms.cv.cities.red.text',
    distributionCenters: [
      {
        title: '',
        address: 'contacts.centers.red.text',
        phone: '+7 495 228 69 08',
        workHours: '08:00-17:00',
        images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
        top: '137px',
        left: '142px',
        cx: '23.5%',
        cy: '40.5%',
        r: '30%',
      },
    ],
  },
  // {
  //   city: 'yelabuga',
  //   address: 'contacts.centers.',
  //   phone: '+7 495 228 69 08',
  //   workHours: '08:00-17:00',
  //   images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
  //   top: '262px',
  //   left: '315px',
  //   cx: '43%',
  //   cy: '64.5%',
  //   r: '30%',
  // },
  // {
  //   city: 'almaty',
  //   address: 'contacts.centers.',
  //   phone: '+7 495 228 69 08',
  //   workHours: '08:00-17:00',
  //   images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
  //   top: '395px',
  //   left: '541px',
  //   cx: '69.5%',
  //   cy: '92%',
  //   r: '30%',
  // },
  // {
  //   city: 'astana',
  //   address: 'contacts.centers.',
  //   phone: '+7 495 228 69 08',
  //   workHours: '08:00-17:00',
  //   images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
  //   top: '320px',
  //   left: '517px',
  //   cx: '66.5%',
  //   cy: '77%',
  //   r: '30%',
  // },
  // {
  //   city: 'minsk',
  //   address: 'contacts.centers.',
  //   phone: '+7 495 228 69 08',
  //   workHours: '08:00-17:00',
  //   images: ['/images/distr.jpg', '/images/distr.jpg', '/images/distr.jpg'],
  //   top: '132px',
  //   left: '39px',
  //   cx: '7%',
  //   cy: '36%',
  //   r: '30%',
  // },
];
